import { render } from "./HouseType.vue?vue&type=template&id=04c66076&scoped=true"
import script from "./HouseType.vue?vue&type=script&lang=js"
export * from "./HouseType.vue?vue&type=script&lang=js"

import "./HouseType.vue?vue&type=style&index=0&id=04c66076&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c66076"]])

export default __exports__